/// <reference types="vite/client" />

/**
 * Safe environment variable accessor for Vite SPA runtime.
 */
export function getEnv(key: string): string {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const metaEnv = import.meta.env as Record<string, any>;
    return String(metaEnv[key] ?? metaEnv[`VITE_${key}`] ?? '');
  }
  return '';
}

export const OIDC_CLIENT_ID = getEnv('VITE_OIDC_CLIENT_ID');
export const OIDC_ISSUER = getEnv('VITE_OIDC_ISSUER');
export const OIDC_REDIRECT_URI = getEnv('VITE_OIDC_REDIRECT_URI');
export const OIDC_LOGOUT_URL = getEnv('VITE_OIDC_LOGOUT_URL');
export const OIDC_LOGOUT_RETURN_TO = getEnv('VITE_OIDC_LOGOUT_RETURN_TO');
export const PP_BASE_URL = getEnv('VITE_PP_BASE_URL');
export const FILE_SERVER_URL = getEnv('VITE_FILE_SERVER_URL');
export const IS_DEV = import.meta.env.DEV;
